import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mw-1720 bg-opacity px-50 position-relative" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "collapse navbar-collapse" }
const _hoisted_5 = { class: "navbar-nav ms-auto" }
const _hoisted_6 = { class: "d-flex ps-0 mb-0 list-unstyled justify-content-end align-items-center others-options" }
const _hoisted_7 = { class: "d-none d-sm-inline-block" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "d-xl-none" }
const _hoisted_10 = {
  key: 0,
  class: "d-none d-xl-flex align-items-center gap-2"
}
const _hoisted_11 = { class: "border-style" }
const _hoisted_12 = { class: "d-none d-xl-block" }
const _hoisted_13 = { class: "d-none d-xl-block" }
const _hoisted_14 = { class: "border-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(['navbar navbar-expand-lg bg-transparent p-0 fixed-top mt-20', { sticky: _ctx.isSticky }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        class: "navbar-brand",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.nav.logo_url || _ctx.defaultLogo,
            class: "main-logo",
            alt: "logo"
          }, null, 8, _hoisted_2),
          _createElementVNode("img", {
            src: _ctx.nav.logo_url || _ctx.defaultLogo,
            class: "white-logo d-none",
            alt: "logo"
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        class: "navbar-toggler",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.responsiveNavbar && _ctx.stateStoreInstance.responsiveNavbar(...args)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("span", { class: "burger-menu" }, [
          _createElementVNode("span", { class: "top-bar" }),
          _createElementVNode("span", { class: "middle-bar" }),
          _createElementVNode("span", { class: "bottom-bar" })
        ], -1)
      ])),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleLinks, (link) => {
            return (_openBlock(), _createElementBlock("li", {
              key: link.url,
              class: "nav-item"
            }, [
              _createVNode(_component_RouterLink, {
                class: "nav-link",
                to: link.url
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(link.label), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("a", {
            href: 'tel:' + _ctx.nav.phone,
            class: "call icon"
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "ti ti-phone-incoming" }, null, -1)
          ]), 8, _hoisted_8)
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createVNode(_component_RouterLink, {
            to: _ctx.authStore.isLoggedIn ? '/dashboard' : '/login',
            class: "search icon"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "ti ti-user" }, null, -1)
            ])),
            _: 1
          }, 8, ["to"])
        ]),
        (_ctx.authStore.isLoggedIn)
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
              _createVNode(_component_RouterLink, {
                to: "/dashboard",
                class: "btn btn-sm"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.authStore.user?.name), 1)
                ]),
                _: 1
              }),
              (_ctx.authStore.isAdmin)
                ? (_openBlock(), _createBlock(_component_RouterLink, {
                    key: 0,
                    to: "/admin",
                    class: "btn btn-sm"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("span", { class: "border-style" }, "Admin", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("span", { class: "border-style" }, "Logout", -1)
              ]))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("li", _hoisted_12, [
                _createVNode(_component_RouterLink, {
                  to: "/login",
                  class: "btn me-2"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createElementVNode("span", { class: "border-style" }, "Login", -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_13, [
                _createVNode(_component_RouterLink, {
                  to: _ctx.nav.cta_url || '/',
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.nav.cta_text || 'Get Started'), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ], 64))
      ])
    ])
  ], 2))
}